import { AvailableLocale, Nullish } from '@omnea-digital/toolbox'

/**
 * Gets the localised display name for a country code
 * @param countryCode - ISO 3166-1 alpha-2 country code (e.g. 'GB', 'US') or nullish
 * @param locale - Locale code (e.g. 'en-GB')
 * @returns The localised country name, if the country code is nullish, the country code is returned
 */
export const getCountryDisplayName = <Code extends Nullish<string>>(
  locale: AvailableLocale,
  countryCode: Code
): Code extends string ? string : Nullish<string> => {
  if (!countryCode) {
    // TODO(DX-113): Remove `as string` when TypeScript 5.9 is out with better conditional return type assertions
    return countryCode as string
  }

  try {
    const formatter = getFormatter(locale)
    return formatter.of(countryCode) || countryCode
  } catch {
    return countryCode
  }
}

// Caching the formatter because otherwise it is instantiated hundreds of times per second in some places
const formatterCache: Partial<Record<AvailableLocale, Intl.DisplayNames>> = {}
const getFormatter = (locale: AvailableLocale) => {
  if (!formatterCache[locale]) {
    formatterCache[locale] = new Intl.DisplayNames(locale, { type: 'region' })
  }
  return formatterCache[locale]
}
